import { useParams } from 'react-router';
import { TestsConfigForm } from './components/tests-config-form';
import { TestsConfigView } from './components/tests-config-view';

export default function TestsPage() {
  const { testId: selectedTestId } = useParams();

  if (selectedTestId === 'new') return <TestsConfigForm />;

  return <TestsConfigView />;
}
